import styled from "@emotion/styled";
import { Divider } from "@mui/material";

export const StyledDivider = styled(Divider)(({ theme }) => ({
    "&.MuiDivider-root::before": {
      display: " none",
      padding: "0px !important",
    },
    "&.MuiDivider-wrapper": {
      paddingLeft: "0px !important",
      color: "red",
    },
  }));